import React from "react";
import Charge from "../component/sections/finance/Charge";
import OfficialInvoice from "../component/sections/finance/OfficialInvoice";
import Invoices from "../component/sections/finance/Invoices";
import Pledge from "../component/sections/finance/Pledge";

const financeRoutes = [
  {
    path: "/finance/charge",
    render: () => <Charge />,
    exact: true,
  },
  {
    path: "/finance/pledge",
    render: () => <Pledge />,
    exact: true,
  },
  {
    path: "/finance/invoices",
    render: () => <Invoices />,
    exact: true,
  },
  {
    path: "/finance/official/:id",
    render: () => <OfficialInvoice />,
    exact: true,
  },
];

export default financeRoutes;
